export const environment = {
  production: false,
  apiUrl: 'https://esign-dev.intrustca.net',
  esignId: 'intrust-esign',
  esignPassword: 'BmcVrkmIDOHUIgJ',
  packageApiUrl: 'https://package.innotary.vn/api',
  packageUsername: 'webIntrust',
  packagePassword: '123456aA@'
};
